export default {
  nav: {
    main: 'Hlavna',
    ordersAndInvoices: 'Objednavky a faktury',
    drafts: 'Koncepty',
    automation: 'Automatizacia',
    workspace: 'Pracovny priestor',
    templates: 'Sablony',
    delivery: 'Dorucenie',
    settings: 'Nastavenia',
    shippingLabels: 'Prepravne stitky',
    subscriptions: 'Predplatne',
    support: 'Podpora',
    developer: 'Vyvojar',
    writeReview: 'Napisat recenziu',
    supportTicket: 'Poziadavka na podporu',
    welcomeTour: 'Uvitacia prehliadka',
    administratorConsole: 'Administratorska konzola',
    logout: 'Odhlasit sa',
  },
  dashboard: {
    pageTitle: 'Objednavky a faktury',
    pageDescription: 'Manage your orders and invoices',
    title: 'Objednavky a faktury',
    selectedOrders: '{count} vybranych objednavok',
    completed: '% dokoncene',
    processing: 'Spracovava sa, prosim cakajte...',
    bulkDownload: 'Hromadne stiahnutie',
    upgradeBulkDownload: 'Prejdite na vyssi plan pre hromadne stiahnutie',
    showFilters: 'Zobrazit filtre',
    hideFilters: 'Skryt filtre',
    creatingInvoices: 'Vytvaraju sa faktury, prosim cakajte...',
    bulkCreateInvoices: 'Hromadne vytvorenie faktur',
    cannotCreateAutopilot: 'Nemozete manualne vytvarat faktury, ked je rezim fakturacii na autopilote.',
    exportInvoices: 'Exportovat faktury alebo objednavky',
    capturePayments: 'Manualne zachytit platby',
    filterOrders: 'Filtrovat objednavky',
    error: 'Hej, nieco sa pokazilo...',
    close: 'Zavriet',
    chooseDate: 'Vyberte datum',
    chooseIssueDate: 'Vyberte datum vystavenia pre vybrane faktury',
    cancel: 'Zrusit',
    createInvoices: 'Vytvorit faktury',
    storno: 'Storno',
    bulkOrderCapture: 'Hromadne zachytenie objednavok',
  },
  search: {
    createdBetween: 'Vytvorene medzi',
    modifiedBetween: 'Upravene medzi',
    orderNumber: 'Objednavka #',
    invoiceNumber: 'Faktura #',
    refundNumber: 'Dobropis #',
    customer: 'Zakaznik',
    payment: 'Platba',
    any: 'Akakolvek',
    authorized: 'Autorizované',
    pending: 'Čaká',
    paid: 'Zaplatené',
    partiallyPaid: 'Čiastočne zaplatené',
    refunded: 'Vrátené',
    voided: 'Zrušené',
    partiallyRefunded: 'Čiastočne vrátené',
    unpaid: 'Nezaplatené',
    fulfillment: 'Vybavenie',
    fulfilled: 'Odoslané',
    partial: 'Čiastočné',
    unfulfilled: 'Neodoslané',
    loading: 'Nacitavaju sa objednavky...',
    search: 'Hladat',
  },
  orderList: {
    noCustomer: 'Ziadny zakaznik',
    downloadOrder: 'Stiahnut objednavku',
    deleteWarning: 'Dolezite! Toto vymaze vsetky faktury a dobropisy vytvorene po datume:',
    includingInvoice: 'vratane vybranej faktury #',
    pressOk: 'Stlacte OK pre pokracovanie alebo Zrusit pre prerusenie.',
    cannotCreateAutopilot: 'Nemozete manualne vytvarat faktury, ked je rezim fakturacii na autopilote.',
    createInvoice: 'Vytvorit fakturu pre tuto objednavku',
    create: 'Vytvorit',
    addCreditNote: 'Pridat dobropis',
    createStorno: 'Vytvorit storno fakturu',
    refund: 'Dobropis',
    downloadInvoice: 'Stiahnut tuto fakturu',
    download: 'Stiahnut',
    default: 'Predvolene',
    downloadStorno: 'Stiahnut toto storno/dobropis',
    fulfillOrder: 'Vybavit objednavku',
    orderNum: 'Objednavka #',
    locPrefix: 'Prefix lokality',
    invoiceNum: 'Faktura #',
    refundNum: 'Dobropis #',
    customerCol: 'Zakaznik',
    orderCreatedDate: 'Datum vytvorenia objednavky',
    orderModifiedDate: 'Datum upravy objednavky',
    delivered: 'Dorucene',
    paymentStatus: 'Stav platby',
    fulfillmentStatus: 'Stav odoslania',
    totalOutstanding: 'Celkova neuhra dena suma',
    originalPrice: 'Povodna cena',
    noOrders: 'Vas obchod nema ziadne objednavky pre vybrany stav.',
    cannotCreateNoOrders: 'Nemozete vytvarat faktury, ked nie su ziadne objednavky.',
    createOrdersFirst: 'Prosim, vytvorte aspon jednu objednavku a skuste znova.',
    createOrders: 'Vytvorit objednavky',
    loadingOrders: 'Nacitava sa...',
    paidManual: 'Zaplatené - Manuálne',
    paid: 'Zaplatené',
    refunded: 'Vrátené',
    pending: 'Čaká',
    partiallyPaid: 'Čiastočne zaplatené',
    partiallyRefunded: 'Čiastočne vrátené',
    fulfilled: 'Odoslané',
    unfulfilled: 'Neodoslané',
    deliveryPending: 'Čaká',
    deliverNow: 'Doručiť teraz',
    deliveryPartial: 'Čiastočné',
    notDelivered: 'Nedoručené',
    deliverAgain: 'Doručiť znova',
    deliveryDetails: 'Podrobnosti doručenia',
    deliveryFailed: 'Doručenie zlyhalo',
    sent: 'Odoslané',
    failed: 'Zlyhalo',
    toLabel: 'Komu',
    folderLabel: 'Priečinok',
    open: 'Otvorené',
    invoice: 'Faktúra',
    creditNote: 'Dobropis',
    stornoLabel: 'Storno',
    unknown: 'Neznáme',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet klientov',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Vrátiť k tomuto dátumu',
    add: 'Pridať',
    close: 'Zavrieť',
  },
  downloadDialog: {
    downloadType: 'Stiahnut {type}...',
    selectTemplate: 'Vyberte sablonu z galerie na export objednavok, faktur, storno faktur alebo dobropisov.',
    getMoreTemplates: 'Ziskat viac sablon',
    createNewTemplate: 'Vytvorit novu sablonu',
    allCreatedBetween: 'Vsetky vytvorene {type} medzi',
    selectedType: 'Vybrane {type}',
    and: 'a',
    status: 'Stav',
    any: 'Akykolvek',
    open: 'Otvorene',
    closed: 'Uzavrete',
    cancelled: 'Zrusene',
    paymentStatus: 'Stav platby',
    fulfillmentStatus: 'Stav odoslania',
    fulfilled: 'Odoslané',
    partial: 'Čiastočné',
    unfulfilled: 'Neodoslané',
    authorized: 'Autorizované',
    pending: 'Čaká',
    paid: 'Zaplatené',
    partiallyPaid: 'Čiastočne zaplatené',
    refunded: 'Vrátené',
    voided: 'Zrušené',
    partiallyRefunded: 'Čiastočne vrátené',
    unpaid: 'Nezaplatené',
    format: 'Formát',
    forLocation: 'Pre pobočku',
    advancedOptions: 'Rozšírené možnosti',
    exportHSCodes: 'Exportovať HS kódy skladu (pomalšie)',
    noteChrome: 'Poznámka: Pre optimálne sťahovanie sa odporúča Chrome a vypnutie blokátora reklám.',
    downloadIndividually: 'Stiahnuť jednotlivo',
    downloadGrouped: 'Stiahnuť skupinovo',
  },
  templates: {
    pageTitle: 'Sablony',
    pageDescription: 'Customize your invoice templates',
    title: 'Sablony',
    installTranslated: 'Instalovat prelozenu sablonu',
    installTranslatedDesc: 'Vyberte iny jazyk kliknutim na toto tlacidlo.',
    createNew: 'V pripade potreby vytvorte novu sablonu',
    createNewDesc: 'Kliknite na toto tlacidlo pre vytvorenie novej sablony.',
    customize: 'Prisposobit sablony',
    customizeDesc: 'Kliknite na predvolenu sablonu pre jej prisposobenie. Mozete zmenit logo, farby a pre pokrocilejsich pouzivatelov aj kod.',
    defaultTemplate: 'Faktura, Storno a Dobropis (Predvolene)',
    logo: 'Logo',
    colorPalette: 'Farebna paleta',
    getColorPalettes: 'Ziskat farebne palety',
    paperSize: 'Velkost papiera',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientacia',
    landscape: 'Na sirku',
    portrait: 'Na vysku',
    margin: 'Okraj (cm)',
    unsavedChanges: 'Neulozene zmeny',
    discard: 'Zahodit',
    save: 'Ulozit',
  },
  labels: {
    pageTitle: 'Prepravne stitky',
    pageDescription: 'Create and manage shipping labels',
    title: 'Prepravne stitky',
    glsRequiresPro: 'GLS prepravne stitky pre VEU vyzaduju plan Professional.',
    upgradeDesc: 'Prejdite na Professional pre vytvaranie a spravu prepravnych stitkov.',
    upgradePlan: 'Prejst na vyssi plan',
    eeuGls: 'VEU GLS',
    enabled: 'Povolene',
    country: 'Krajina',
    hungary: 'Madarsko',
    slovakia: 'Slovensko',
    czech: 'Cesko',
    romania: 'Rumunsko',
    slovenia: 'Slovinsko',
    croatia: 'Chorvatsko',
    senderId: 'ID odosielatela',
    username: 'Pouzivatelske meno',
    password: 'Heslo',
    name: 'Meno',
    city: 'Mesto',
    address: 'Adresa',
    zipCode: 'PSC',
    contactPerson: 'Kontaktna osoba',
    phone: 'Telefon',
    email: 'Email',
    glsServices: 'GLS sluzby',
    expressService: 'Expresna sluzba',
    exchangeService: 'Vymenna sluzba',
    smsService: 'SMS sluzba',
    smsText: 'Text SMS',
    preAdviceService: 'Sluzba PreAdvice',
    unsavedChanges: 'Neulozene zmeny',
    discard: 'Zahodit',
    save: 'Ulozit',
  },
  billing: {
    pageTitle: 'Fakturacia',
    pageDescription: 'Manage your subscription and billing',
    title: 'Fakturacia',
    subscriptionFor: 'Plan predplatneho pre obchod',
    currentlySubscribed: 'V sucasnosti ste predplateni na',
    plan: 'plan',
    cancelSubscription: 'Zrusit predplatne',
    upgradePlan: 'Prejst na vyssi plan',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / mesiac',
    upgrade: 'Prejst na vyssi plan',
    includesAllStarter: 'Zahrnuje vsetky funkcie Starter, plus:',
    proFeature1: 'Globalna zhoda: Prefixy podla lokality a vlastne sekven cne cislovanie',
    proFeature2: 'Inteligentna lokalizacia: Automaticky prelozene emaily a lokalizovane PDF prilohy',
    proFeature3: 'Kompletny B2B zivotny cyklus dokumentov: Proformy, B2B cenove ponuky a dobropisy',
    proFeature4: 'B2B uctovny sync: 3-desatinna presnost jednotiek a zobrazenie viacerych mien',
    proFeature5: 'Automaticke zalohy: Kopirovat faktury automaticky na zabezpeceny FTP alebo Google Drive',
    proFeature6: 'Shopify Flow: Automatizovat generovanie, dorucovanie a storno faktur cez Flow triggery a akcie',
    proFeature7: 'Pokrocila AI logika: Pouzite zabudovanu AI pre zlozite podmienene klauzuly rozlozenia',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X exporty (europska zhoda s e-fakturacou)',
    proFeature9: 'EPC QR kody pre okamzite mobilne POS platby',
    proFeature10: 'GLS prepravne stitky pre VEU',
    proFeature11: '7-rocne uchovavanie danovych dokladov',
    currentlyUsing: 'V sucasnosti pouzivate nas',
    free: 'bezplatny',
    subscriptionPlan: 'plan predplatneho.',
    monthlyUsage: 'Mesacne vyuzitie',
    monthlyGenerated: '{count} / 50 faktur tento mesiac',
    monthlyLimitReached: 'Mesacny limit dosiahnuty. Prejdite na Starter pre neobmedzene faktury.',
    freePlan: 'Bezplatny plan',
    freeToInstall: 'Instalacia zdarma',
    freeFeature1: 'Az 50 faktur/objednavok mesacne',
    freeFeature2: 'Pristup ku vsetkym 31+ preddefinovanym sablonam',
    freeFeature3: 'Zakladny AI Copilot',
    freeFeature4: 'Standardne stahovanie a tlac PDF',
    freeFeature5: 'Standardna sada dokumentov (Faktury, Dodacie listy, Prijmove doklady)',
    freeFeature6: '3-mesacne bezpecne uchovavanie faktur',
    starterPlan: 'Starter plan',
    starterPrice: '$9.99 / mesiac',
    starterPricePerInvoice: '+ 3¢ za kazdu vytvorenu fakturu',
    subscribe: 'Predplatit',
    starterFeature1: 'Neobmedzene faktury a objednavky',
    starterFeature2: 'Automaticke dorucovanie PDF emailom',
    starterFeature3: 'Plny pristup k hybridnemu editoru a AI Copilot',
    starterFeature4: 'Shopify POS a integracia ciaroveho kodu',
    starterFeature5: 'Shopify Flow: Triggery a akcie pre automatizaciu faktur',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X exporty (zhoda s e-fakturacou)',
    starterFeature7: '1-rocne bezpecne uchovavanie faktur',
    proTaxOverrides: 'Vlastne danove prepisanie: DPH podla produktu a sadzby na urovni SKU',
    unsavedChanges: 'Neulozene zmeny',
    discard: 'Zahodit',
    save: 'Ulozit',
  },
  autopilot: {
    pageTitle: 'Automatizacia',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizacia',
    autoCreate: 'Automaticky vytvarat faktury',
    disabled: 'Vypnute (Manualne)',
    whenCreated: 'Ked su objednavky vytvorene',
    whenFulfilled: 'Ked su objednavky vybavene',
    whenPaid: 'Ked su objednavky zaplatene',
    autoCreateDesc: 'Faktury budu vytvorene v den, ked su objednavky vytvorene, vybavene alebo zaplatene.',
    autoStorno: 'Automaticky stornovat faktury',
    whenCancelled: 'Ked su objednavky zrusene alebo vratene',
    autoStornoDesc: 'Storno faktury budu vytvorene v den, ked su objednavky zrusene alebo su vytvorene dobropisy.',
    cannotAutoFree: 'Automaticke vytvaranie faktur nie je mozne s bezplatnym planom.',
    upgradePlan: 'Prejst na vyssi plan',
    unsavedChanges: 'Neulozene zmeny',
    discard: 'Zahodit',
    save: 'Ulozit',
  },
  delivery: {
    pageTitle: 'Dorucenie',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Dorucenie',
    settings: 'Nastavenia',
    useOrderNumbers: 'Pouzit cisla objednavok pre subory',
    sendIfCountry: 'Odoslat ak krajina fakturacnej adresy je',
    countryCodesHint: 'Uvedte vsetky kody krajin oddelene bodkociarkou.',
    sendForTags: 'Odoslat pre zakaznikov, ktori maju jeden z uvedenych tagov',
    tagsHint: 'Uvedte vsetky tagy oddelene bodkociarkou.',
    emailDelivery: 'Dorucenie emailom',
    sendAsPdf: 'Posielat faktury ako PDF prilohy zakaznikom',
    autoSend: 'Automaticky odoslat pri vytvoreni faktury',
    subject: 'Predmet',
    body: 'Telo spravy',
    xmlAttachments: 'XML prilohy',
    attachUbl: 'Prilozit UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Prilozit ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Odoslat testovaci email',
    sending: 'Odosielanie...',
    customSmtp: 'Vlastny SMTP server',
    customSmtpDesc: 'Pouzite vlastny mailovy server namiesto predvoleneho',
    enableSmtp: 'Povolit vlastny SMTP',
    smtpHost: 'SMTP Host',
    port: 'Port',
    useSsl: 'Pouzit SSL/TLS',
    username: 'Pouzivatelske meno',
    password: 'Heslo',
    fromEmail: 'Email odosielatela',
    fromName: 'Meno odosielatela',
    shopifyLiquid: 'Shopify Liquid sablona',
    pasteInto: 'Vlozte toto do vasej',
    orderConfirmation: 'sablony potvrdenia objednavky',
    toAddLink: 'pre pridanie odkazu na stiahnutie.',
    downloadInvoice: 'Stiahnut vasu fakturu',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Odoslat poziadavky do ClientsTablet pri vytvoreni faktur',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Odoslat PDF faktury ako colne dokumenty do ShippyPro pre krajiny mimo EU',
    ftpBackup: 'FTP/SFTP zaloha',
    ftpDesc: 'Automaticky kopirovat faktury na vas server',
    enableFtp: 'Povolit automaticku FTP zalohu',
    host: 'Host',
    useSftp: 'Pouzit SFTP (zabezpecene)',
    destinationFolder: 'Cielovy priecinok',
    xmlFiles: 'XML subory',
    includeUbl: 'Zahnut UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Zahnut ZUGFeRD / Factur-X XML',
    testConnection: 'Testovat pripojenie',
    testing: 'Testuje sa...',
    pro: 'PRO',
    upgradeFtp: 'Prejdite na Professional pre automaticke kopírovanie faktur na vas FTP/SFTP server.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Automaticky synchronizovat faktury na vas Drive',
    connected: 'Pripojene',
    disconnect: 'Odpojit',
    notWorking: 'Nefunguje? Prejdite na',
    googlePermissions: 'Google povolenia',
    removeThenReconnect: 'odstranit Invoice Browse, potom znova pripojit.',
    connectGoogleDrive: 'Pripojit Google Drive',
    upgradeGoogleDrive: 'Prejdite na Professional pre automaticku synchronizaciu faktur na Google Drive.',
    unsavedChanges: 'Neulozene zmeny',
    discard: 'Zahodit',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Ulozit',
  },
  bookkeeping: {
    pageTitle: 'Nastavenia',
    pageDescription: 'Configure your invoice settings',
    title: 'Nastavenia',
    owner: 'Vlastnik',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Zachovat odlisne cislovanie faktur pre kazdu lokalitu objednavky',
    keepDifferentNumberingDisabled: 'Zachovanie odlisneho cislovania faktur pre kazdu lokalitu objednavky nie je dostupne s vasim planom.',
    locationEmailDesc: 'Toto vam umoznuje posielat emaily a faktury prelozene podla lokality objednavky: sklad, dodacia alebo fakturacna adresa',
    upgradePlan: 'Prejst na vyssi plan',
    matchingCriteria: 'Kriteria zhody',
    locationId: 'ID lokality',
    shippingCountryCode: 'Kod krajiny dodacej adresy',
    billingCountryCode: 'Kod krajiny fakturacnej adresy',
    matchLocationDesc: 'Priradit lokalitu podla ID lokality objednavky, kodu krajiny dodacej alebo fakturacnej adresy.',
    companyInfo: 'Informacie o spolocnosti',
    name: 'Nazov',
    website: 'Webova stranka',
    registrationNumber: 'ICO',
    taxId: 'DIC',
    addressSection: 'Adresa',
    streetName: 'Nazov ulice',
    streetNumber: 'Cislo domu',
    zip: 'PSC',
    city: 'Mesto',
    region: 'Kraj',
    country: 'Krajina',
    bankingInfo: 'Bankove udaje',
    bankName: 'Nazov banky',
    swift: 'Swift',
    currency: 'Mena',
    iban: 'IBAN',
    invoicing: 'Fakturacia',
    decimalPlaces: 'Desatinne miesta',
    invoicesPrefix: 'Prefix faktur',
    currentInvoiceNumber: 'Aktualne cislo faktury',
    creditNotesPrefix: 'Prefix dobropisov',
    currentCreditNoteNumber: 'Aktualne cislo dobropisu',
    lastInvoiceDate: 'Datum poslednej faktury',
    noInvoicesYet: 'Zatial neboli vytvorene ziadne faktury.',
    confirmReverting: 'Potvrdenie vratenia systemu',
    allInvoicesAfter: 'Vsetky faktury a ich storno vystavene po',
    willBeRemoved: 'budu odstranene. Pokracovat s vratenim systemu?',
    cancel: 'Zrusit',
    revert: 'Vratit',
    revertDesc: 'Vratenie systemu vymaze vsetky faktury vytvorene po vybranom datume.',
    revertToDate: 'Vratit k tomuto datumu',
    reverting: 'Vracia sa system, prosim cakajte...',
    useOrderNumbering: 'Pouzit cislovanie objednavok',
    showVat: 'Zobrazit DPH na fakturach',
    overrideTaxes: 'Prepisat dane',
    pricesIncludeTax: 'Ceny obsahuju dan',
    productsTaxRate: 'Sadzba dane produktov',
    shippingTaxRate: 'Sadzba dane dopravy',
    skusSeparated: 'SKU oddelene bodkociarkou',
    skusTaxRate: 'Sadzba dane SKU',
    useOrderDates: 'Pouzit datumy vytvorenia objednavok pre faktury',
    convertCurrency: 'Previest ceny na menu, v ktorej zakaznik plati',
    unsavedChanges: 'Neulozene zmeny',
    discard: 'Zahodit',
    save: 'Ulozit',
  },
  drafts: {
    pageTitle: 'Koncepty',
    pageDescription: 'Manage your draft orders',
    title: 'Koncepty',
    download: 'Stiahnut',
    newDraft: 'Novy koncept',
    exporting: 'Exportuje sa {status}%...',
    accessNotGranted: 'Pristup ku konceptom objednavok nebol udeleny. Prosim',
    reLogin: 'prihlaste sa znova',
    toGrantPermissions: 'pre udelenie pozadovanych opravneni "Koncepty objednavok".',
    pushFailed: 'Odoslanie do Shopify zlyhalo:',
    exportError: 'Chyba exportu:',
    confirmDelete: 'Naozaj chcete vymazat tento koncept?',
    incompleteCustomer: 'Udaje zakaznika su nekompletne:',
    pushWithoutCustomer: 'Koncept bude odoslany do Shopify bez udajov zakaznika. Pokracovat?',
    customerNotInShopify: 'Tento zakaznik este neexistuje v Shopify.',
    warnings: 'Upozornenia:',
    createCustomerAndPush: 'Vytvorit zakaznika v Shopify a odoslat koncept objednavky?',
    downloadTitle: 'Stiahnuť koncepty',
    cancel: 'Zrušiť',
  },
  draftEdit: {
    number: "Cislo",
    prefix: "Predpona",

    newDraft: 'Novy koncept',
    editDraft: 'Upravit koncept',
    viewInShopify: 'Zobrazit v Shopify',
    back: 'Spat',
    createDraft: 'Vytvorit koncept',
    saveChanges: 'Ulozit zmeny',
    documentType: 'Typ dokumentu',
    draftOrder: 'Koncept objednavky',
    quote: 'Cenova ponuka',
    proforma: 'Proforma',
    manualInvoice: 'Manualna faktura',
    currency: 'Mena',
    expiryDate: 'Datum platnosti',
    status: 'Stav',
    draft: 'Koncept',
    sent: 'Odoslane',
    accepted: 'Prijate',
    customer: 'Zakaznik',
    firstName: 'Meno',
    lastName: 'Priezvisko',
    email: 'Email',
    phone: 'Telefon',
    company: 'Spolocnost',
    taxId: 'DIC',
    billingAddress: 'Fakturacna adresa',
    address: 'Adresa',
    aptSuite: 'Byt/Apartman',
    city: 'Mesto',
    province: 'Kraj',
    countryField: 'Krajina',
    zip: 'PSC',
    shippingAddress: 'Dodacia adresa',
    sameAsBilling: 'Rovnaka ako fakturacna',
    lineItems: 'Polozky',
    shipping: 'Doprava',
    shippingTitle: 'Nazov',
    shippingPlaceholder: 'napr. Standardna doprava',
    price: 'Cena',
    note: 'Poznamka',
    notePlaceholder: 'Interna poznamka alebo sprava zakaznikovi...',
    summary: 'Suhrn',
    subtotal: 'Medzisucet',
    discounts: 'Zlavy',
    tax: 'Dan',
    total: 'Celkom',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Zadajte adresu vasho obchodu',
    loginWith: 'Prihlasit sa cez',
    createAccount: 'Vytvorit novy ucet',
    placeholder: 'nazov-vasho-obchodu',
    shopRequired: 'Nazov obchodu je povinny',
    login: 'Prihlasit sa',
    shopify: 'Shopify',
    terms: 'Obchodne podmienky',
    privacy: 'Zasady ochrany osobnych udajov',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Paci sa vam Invoice Browse?',
    description: 'Vytvorili ste svoje prve faktury! Ak vam je aplikacia uzitocna, rychla recenzia v Shopify App Store nam velmi pomoze.',
    reward: 'Ako podakovanie vam vynulujeme pocitadlo mesacneho vyuzitia na 0',
    leaveReview: 'Zanechat recenziu',
    maybeLater: 'Mozno neskor',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Vitajte v Invoice Browse',
    welcomeContent: 'Dovolte mi ukazat vam, ako ho mozete pouzivat.',
    dashboardTitle: 'Prehlad',
    dashboardContent: 'Obrazovka, ktoru vidite, je hlavny prehlad. Tu najdete vsetky objednavky a mozete ich exportovat do roznych typov dokumentov ako: faktury, dodacie listy a dalsie.',
    automationTitle: 'Ulahcite si zivot',
    automationContent: 'Zapnite automatizaciu pre vytvaranie faktur vzdy, ked su objednavky zaplatene alebo vratene.',
    templatesTitle: 'Prisposobit sablony',
    templatesContent: 'Vstupte sem pre prelozenie vasej sablony, jej prisposobenie alebo vytvorenie novej.',
    deliveryTitle: 'Dorucenie',
    deliveryContent: 'Nakonfigurujte nasu aplikaciu na automaticke kopírovanie vytvorenych dokumentov na FTP, Google Drive alebo ako prilohy emailov.',
    settingsTitle: 'Nastavenia',
    settingsContent1: 'Upravte telefonne cislo spolocnosti, email a dalsie polia pouzivane na dokumentoch.',
    settingsContent2: 'Zmente pociatocne cislo dokumentu alebo vymazte dokumenty vytvorene po urcitom datume.',
    settingsContent3: 'Prepisat sadzby DPH pre dopravu a produkty',
    settingsContent4: 'Zmenit desatinne miesta pre cisla',
    reviewTitle: 'Napisat recenziu',
    reviewContent: 'Podporte nas tim napisanim dobrej recenzie!',
    tourTitle: 'Uvitacia prehliadka',
    tourContent: 'Hej, tuto prehliadku mozete znova otvorit odtialto.',
    createDocTitle: 'Vytvorte svoj prvy dokument',
    createDocContent: 'Kliknite na tlacidlo Vytvorit pre vytvorenie vasho prveho dokumentu.',
    docNumberTitle: 'Cislo dokumentu',
    docNumberContent: 'Prvy dokument ma pridelene cislo 1. Ak chcete zacat inym cislom, mozete to zmenit v Nastaveniach.',
    downloadDocTitle: 'Stiahnut dokument',
    downloadDocContent: 'Kliknite na rozbalovaci zoznam Stiahnut a vyberte sablonu dokumentu pre export vasej objednavky ako PDF.',
  },
  common: {
    save: 'Ulozit',
    cancel: 'Zrusit',
    close: 'Zavriet',
    discard: 'Zahodit',
    delete: 'Vymazat',
    edit: 'Upravit',
    create: 'Vytvorit',
    loading: 'Nacitava sa...',
    unsavedChanges: 'Neulozene zmeny',
    upgradePlan: 'Prejst na vyssi plan',
  },
  languageSelector: {
    label: 'Jazyk',
    auto: 'Automaticka detekcia',
  },
  draftList: {
    draftNum: 'Koncept #',
    shopifyId: 'Shopify ID',
    type: 'Typ',
    customer: 'Zákazník',
    total: 'Celkom',
    status: 'Stav',
    delivered: 'Doručené',
    date: 'Dátum',
    actions: 'Akcie',
    noCustomer: 'Bez zákazníka',
    noDrafts: 'Žiadne koncepty ani ponuky.',
    loading: 'Načítava sa...',
    download: 'Stiahnuť',
    default: 'Predvolené',
    pending: 'Čakajúce',
    deliverNow: 'Doručiť teraz',
    deliveryDetails: 'Podrobnosti doručenia',
    sent: 'Odoslané',
    failed: 'Zlyhalo',
    deliverAgain: 'Doručiť znova',
    partial: 'Čiastočne',
    notDelivered: 'Nedoručené',
    deliveryFailed: 'Doručenie zlyhalo',
    unknown: 'Neznáme',
    edit: 'Upraviť',
    send: 'Odoslať',
    pushToShopify: 'Odoslať do Shopify',
    complete: 'Dokončiť',
    duplicate: 'Duplikovať',
    delete: 'Zmazať',
    quote: 'Ponuka',
    proforma: 'Proforma',
    draftOrder: 'Koncept objednávky',
    manualInvoice: 'Manuálna faktúra',
  },
  draftSearch: {
    createdBtw: 'Vytvorené medzi',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Zákazník',
    status: 'Stav',
    type: 'Typ',
    delivery: 'Doručenie',
    any: 'Všetky',
    draft: 'Koncept',
    sent: 'Odoslané',
    accepted: 'Prijaté',
    expired: 'Vypršané',
    converted: 'Prevedené',
    cancelled: 'Zrušené',
    quote: 'Ponuka',
    proforma: 'Proforma',
    draftOrder: 'Koncept objednávky',
    manualInvoice: 'Manuálna faktúra',
    delivered: 'Doručené',
    notDelivered: 'Nedoručené',
    pending: 'Čakajúce',
    search: 'Hľadať',
  },
  draftDownload: {
    title: 'Stiahnuť Koncept #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Stav',
    documentType: 'Typ',
    any: 'Všetky',
    draft: 'Koncept',
    sent: 'Odoslané',
    accepted: 'Prijaté',
    expired: 'Vypršané',
    converted: 'Prevedené',
    cancelled: 'Zrušené',
    quote: 'Ponuka',
    proforma: 'Proforma',
    draftOrder: 'Koncept objednávky',
    manualInvoice: 'Manuálna faktúra',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Nainštalovať novú šablónu',
    tabStyle: 'Štýl',
    tabContent: 'Obsah',
    tabTranslations: 'Preklady',
    tabSettings: 'Nastavenia',
    tabCode: 'Kód',
    tabCopilot: 'AI Kopilot',
    logo: 'Logo',
    colorPalette: 'Farebná paleta',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/sk.js